import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

import { useAccountSettings } from './useAccountSettings';

export const LEAD_QUERY_BY_EMAIL = gql`
  query LeadDetailsQuery($email: Email!) {
    leadV2(filter: { email: $email }) {
      uuid
      firstName
      lastName
      email
      phone
      entityName
      entityType
      jurisdictionCode
      flowName
      planFlow
    }
  }
`;

export function useLeadDetails() {
  const { data: accountInfo, loading: accountLoading } = useAccountSettings();

  const email = accountInfo?.accountEmail;

  const {
    data, loading: leadLoading, errors
  } = useQuery(LEAD_QUERY_BY_EMAIL, {
    noThrow: true,
    skip: !email, // Skip the query when email is not available
    variables: {
      email
    }
  });

  const filteredErrors = errors?.filter((error) => error.extensions?.errorCode !== 'LEAD_NOT_FOUND') || [];

  useError(filteredErrors);

  return {
    data: data?.leadV2 || {},
    error: errors?.[0] || null,
    loading: accountLoading || (email && leadLoading)
  };
}
